import React, {FC, useEffect, useState} from "react";
import Breadcrumb from "../../../components/common/Breadcrumbs";
import OrderDetailsTab from "./OrderDetailsTab";
import FinishingTab from "./FinishingTabs";
import "../order.css";
import {useLocation, useParams} from "react-router-dom";
import PropertyDetailTab from "./section/PropertyDetailTab";
import {useGetEnumsQuery} from "../../../app/globalApi";
import {useGetAllStatesQuery} from "../../data/states/statesApi";
import {formatValueAsDate} from "../../../helpers/utils/DateUtils";
import {useLazyGetOrderByOrderIdAndTypeQuery} from "../ordersApi";
import _ from "lodash";
import Preloader from "../../../components/common/Preloader";

const ReOrder: FC = () => {

    let {orderId} = useParams();

    const [orderQuery, orderByIdResponse] = useLazyGetOrderByOrderIdAndTypeQuery();
    const {data: enums} = useGetEnumsQuery("");
    const [tab, setTab] = useState(1);
    const statesApiResult = useGetAllStatesQuery("");

    useEffect(() => {
        orderQuery({orderId: orderId, orderType: "RE-ORDER"});
    }, []);

    interface TabProps {
        isActive: boolean;
        label: string;
    }

    const location = useLocation();
    const {
        orderNumber,
        customerId,
        branchId
    } = location.state || {};

    const [createOrderData, setCreateOrderData] = useState<any>({});

    useEffect(() => {
        let orderObject = orderByIdResponse?.data;

        if (orderObject) {
            setCreateOrderData({
                orderNumber: orderNumber,
                customerId: customerId,
                branchId: branchId,
                sellers: orderObject?.sellerName ? orderObject?.sellerName?.split('||').map((name: string) => name.trim()) : [],
                closingAgent: orderObject?.closingAgent,
                buyers: orderObject?.buyerName ? orderObject?.buyerName?.split('||').map((name: string) => name.trim()) : [],
                properties: orderObject?.properties?.map((property: any) => ({
                    sequence: property.sequence,
                    address: {
                        streetAddress: property.addressLine1,
                        city: property.city,
                        state: {
                            label: statesApiResult?.data?.filter((el: any) => el.stateAbbreviation == property.state)[0].stateName,
                            value: property.state
                        },
                        zip: property.zip
                    },
                    accountNumber: property.accountNumber,
                    countyName: {
                        label: property.countyName,
                        value: property.countyName
                    },
                    legalDescription: property.legalDescription,
                    propertyRequestSource: property.propertyRequestSource,
                    propertyType: {
                        value: enums?.["PropertyType"].filter((el: any) => el.constant === property.addressType)[0]?.constant,
                        label: enums?.["PropertyType"].filter((el: any) => el.constant === property.addressType)[0]?.value
                    }
                })),
                isRush: !!orderObject?.rushDate,
                needByDate: orderObject?.needByDate ? formatValueAsDate(orderObject?.needByDate, "YYYY-MM-DD") : "",
                expectedClosingDate: orderObject?.expectedClosingDate ? formatValueAsDate(orderObject?.expectedClosingDate, "YYYY-MM-DD") : "",
                products: _.map(
                    _.filter(orderObject.products, (curValue) =>
                        curValue.type !== "NTP" && curValue.type !== "UNKNOWN"
                    ),
                    (curValue) => {
                        const product = enums?.["ProductType"]?.find(
                            (el: any) => el.constant === curValue.type
                        );

                        return {
                            label: product?.value,
                            value: product?.constant,
                        };
                    }
                )
            })
        }

    }, [orderByIdResponse?.data]);


    const [crumbs] = useState([
        {content: "Home", url: "/home"},
        {content: "Orders", url: "/orders"},
        {content: orderNumber, url: "/orders/" + orderId},
        {content: "Update Order", url: ""},
    ]);


    useEffect(() => {
        document.title = orderNumber;
    });


    const Tab: FC<TabProps> = ({isActive, label}) => (
        <div
            className={`col-span-4 order_tab_outer sm:mt-3 md:mt-0 mt-3 ${isActive ? "bg-highlight-0 active_tab" : "inactive_tab"}`}>
            <h3 className="text-text-0 py-2 px-6 relative">{label}</h3>
        </div>
    );

    return (
        <>
            {orderByIdResponse?.isLoading ? <Preloader/> : <div className="px-5 py-5">
                <Breadcrumb crumbs={crumbs}/>

                <div className="flex justify-center mt-3">
                    <div className="bg-text-0 lg:w-4/6 sm:w-full p-5 rounded-md shadow-[0_0_10px_-2px_rgba(0,0,0,0.2)]">
                        <div className="gap-4 grid-cols-12 sm:block md:grid pb-4 border-b border-surface-5">
                            <Tab isActive={tab === 1} label="Add Order"/>
                            <Tab isActive={tab === 2} label="Add Property"/>
                            <Tab isActive={tab === 3} label="Finishing Up"/>
                        </div>
                        {/* Order tab */}
                        {
                            tab === 1 && <OrderDetailsTab setTab={setTab} createOrderData={createOrderData}
                                                          setCreateOrderData={setCreateOrderData} isReorder={true} orderData={orderByIdResponse}/>
                        }
                        {/* Package tab */}
                        {
                            tab === 2 &&
                            <PropertyDetailTab setTab={setTab}
                                               createOrderData={createOrderData}
                                               setCreateOrderData={setCreateOrderData}
                            />
                        }

                        {/* Finishing tab */}
                        {
                            tab === 3 && <FinishingTab setTab={setTab} createOrderData={createOrderData}
                                                       setCreateOrderData={setCreateOrderData}/>
                        }
                    </div>
                </div>
            </div>}
        </>
    );
};

export default ReOrder;
